<template lang="">
    <div>
      <p v-if="missing_ingredients.length >0">
        <b>{{ $t("recipe.missing_ingredients") }}</b>
       <!-- <pre>{{ missing_ingredients}}</pre>-->
        <ul>
          <template v-if="!withData">
                    <li v-for="i in missing_ingredients" :key="i.ingredient.id">{{ $t(i.ingredient.key) }} {{ i.missing }} {{ !!i.unit?$t(i.unit.key):'' }}  </li>
          </template>
          <template v-if="withData">
                    <li v-for="i in missing_ingredients" :key="i.ingredient.data.attributes.id">{{ $t(i.ingredient.data.attributes.key) }} {{ i.missing }} {{ !!(i.unit.data)?$t(i.unit.data.attributes.key):''}}</li>
          </template>

        </ul>
      </p>

        <ConfirmButton v-if="!showDeepLink" @yes="start()" text="appliance.start_cycle"></ConfirmButton>
        <a :href="deep_link"  v-if="showDeepLink"><Button @click="$emit('recipeStarted')">{{ $t("appliance.deep_link_button") }}</Button>
        </a>
    </div>
</template>
<script>
import { importTranslations } from "../service/Utils";
import ConfirmButtton from "./ConfirmButton";

export default {
  data() {
    return {
      deep_link: '',
      showDeepLink: false,
      withData: false,
      missing_ingredients: []
    };
  },
  props: ["selectedRecipe"],
  async mounted() {
    let self = this;

    importTranslations(this.selectedRecipe.ingredients, this.$i18n, 'ingredient','value');
    await this.$store.dispatch("userstorage/fetch");

    //this.$store.dispatch("appliance/start", this.selectedRecipe);
    let storage_ingredients = this.$store.getters["userstorage/storage"];
    let recipe_ingredients = this.selectedRecipe.ingredients;
    
    let missing_ingredients = recipe_ingredients.reduce((acc, i) => {
      if (typeof i.ingredient.id != 'undefined') {
          if ((i.ingredient.id in storage_ingredients) && (storage_ingredients[i.ingredient.id].value < i.value)) {
            acc.push({ ...i, missing: i.value - storage_ingredients[i.ingredient.id].value });
          } else if (!(i.ingredient.id in storage_ingredients)) {
            acc.push({ ...i, missing: i.value });
          }
        }
        else {
          self.withData = true;
          if ((i.ingredient.data.id in storage_ingredients) && (storage_ingredients[i.ingredient.data.id].value < i.value)) {
            acc.push({ ...i, missing: i.value - storage_ingredients[i.ingredient.data.id].value });
          } else if (!(i.ingredient.data.id in storage_ingredients)) {
            acc.push({ ...i, missing: i.value });
          }
        }
      return acc;
    }, []);

    this.missing_ingredients = missing_ingredients;
    importTranslations(this.missing_ingredients, this.$i18n, 'unit','value');
  },
  methods: {
    async start() {
      let durata =
            parseInt(this.selectedRecipe.cooking_time) +
            parseInt(this.selectedRecipe.prep_time);
          //callback to execute when user confirms the action
          let start_time = new Date();
          // add seconds
          let end_time = new Date(start_time.getTime() + durata * 60 * 1000);
          let deep_link = "https://hon.he.services/kof/OV?prCode=5&prPosition=2&tempSel=200&prTime=60";
          let payload = `
    {
      "prTime": 60,
      "recipe": "PL_recipe",
      "tempSel": 200
    }`;
    payload = payload.replace("\"PL_recipe\"", this.selectedRecipe.id);


          let command = {
            start_time: start_time,
            end_time: end_time,
            capability: 20, // Oven recipe id
            payload: payload,
          };

          //console.log(command);
          await this.$store.dispatch("appliance/command", command);
         
          this.deep_link = deep_link;
          this.showDeepLink = true;
         

    },
  },
  components: {
    ConfirmButton: ConfirmButtton,
  },
};
</script>
<style lang="">
</style>